/* esm.sh - applesauce-relay@5.2.0 */
export * from "/*applesauce-relay@5.2.0/esnext/applesauce-relay.mjs";
